import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { ARTICLES, readingTime } from "../journal/articles";

const ITEMS = ARTICLES.filter((a) => a.property === "dune-villas").slice(0, 3);

export const DuneJournal = () => (
  <section data-testid="dune-journal" className="bg-white py-20 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-moss">From the journal</p>
          <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-licorice sm:text-5xl">
            Planning your stay
          </h2>
        </div>
        <Link to="/journal" data-testid="dune-journal-all-link" className="inline-flex items-center gap-2 border-b border-brand-licorice pb-1 text-[13px] font-semibold uppercase tracking-[0.16em] text-brand-licorice transition-opacity hover:opacity-60">
          All articles <ArrowUpRight size={16} strokeWidth={1.75} />
        </Link>
      </Reveal>
      <div className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-3">
        {ITEMS.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}>
            <Link to={`/journal/${a.slug}`} data-testid={`dune-journal-${a.slug}`} className="group block">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={a.cover} alt={a.coverAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]" />
              </div>
              <p className="mt-5 text-[11px] font-medium uppercase tracking-[0.18em] text-brand-licorice/50">{readingTime(a)} min read</p>
              <h3 className="mt-2 font-serif text-2xl font-light leading-snug text-brand-licorice transition-colors group-hover:text-brand-brunswick">{a.title}</h3>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
